import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { SurveySearchFilter, SurveyGridTable } from "@survey/components";
import { mapActions, mapGetters, mapMutations } from "vuex";
import * as types from "@survey/store/types";
import * as accountTypes from "@account/store/types";
import * as menuHelper from "@appbase/util/menu-helper";
import api from "@survey/api";
import * as dateutil from "@appbase/util/date-helper";

@Component({
    components: {
        SurveySearchFilter,
        SurveyGridTable,
    },
    methods: {
        ...mapActions({
            getList: types.SURVEY_LIST,
            setSurveyId: types.SURVEY_CREATED_SURVEYID,
        }),

        ...mapMutations({
            fethPageset: types.SURVEY_PAGESET,
        }),
    },
    computed: {
        ...mapGetters({
            user: accountTypes.USER,
            current: accountTypes.CURRENT,
            pageSet: types.SURVEY_PAGESET,
            menuPermission: types.SURVEY_MENU_PERMISSIONS,
            listTotalCount: types.SURVEY_LIST_TOTALCOUNT,
            surveyList: types.SURVEY_LIST,
        }),
    },
})
export default class SurveyListView extends Vue {
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: A C T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    fethPageset!: (pageSet: survey.SurveyListRequest) => void;
    getList!: (params: survey.SurveyListRequest) => void;
    setSurveyId!: (surveyId?: number) => void;

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    user!: account.User;
    current!: account.TCurrent;
    menuPermission!: survey.MenuPermissions;
    listTotalCount!: number;
    pageSet!: survey.SurveyListRequest;
    surveyList!: survey.SurveyListResponse;
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //
    isPopup: boolean = false;
    isComposing: boolean = false;
    clickSearchBtn: boolean = false;
    surveyRequest: survey.SurveyRequest = {
        mainInfo: {
            surveyId: 0,
            title: "",
            description: "",
            isPublic: false,
            isAnonymous: false,
            isTargetAll: false,
            startDate: dateutil.uGetDate(-1, new Date(), "month"),
            endDate: dateutil.uGetDate(+1, new Date(), "date"), //new Date(),
            resultStartDate: new Date(),
            resultEndDate: new Date(),
            status: 0,
            fileCode: "",
            menuId: 0,
            isApproval: false,
        },
    } as survey.SurveyRequest;
    selected: number[] = [];
    type: number = 1;
    isSurveyAdmin: boolean = false;
    listSelected: survey.SurveyListItem[] = [];

    @Watch("pageSet")
    onPagesetChanged(newVal: survey.SurveyListRequest) {
        this.getList(newVal);
    }

    created() {
        // 권한그룹 중 '설문조사 관리자 그룹'인 경우에도 관리자 권한 추가
        const isSurveyAdminRole = this.current.permissions.roles.find((x) => 
            x.roleType.toLowerCase() == "admin" && x.subSystemCode.toLowerCase() == "survey") ? true : false;
        this.isSurveyAdmin = this.current.permissions.isSuperAdmin || this.current.permissions.isCompanyManager || isSurveyAdminRole;
        this.setMenuTitle();
        this.getList(this.pageSet);
    }
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    select(item: survey.SurveyListItem[]) {
        this.listSelected = item;
        this.selected = item.map((i) => i.surveyId);
    }

    selectedCheck(length: number) {
        return this.listSelected.length == length;
    }

    async setApproval(isApproval: boolean) {
        if (this.listSelected.length == 0) {
            (window as any).alertAsync(this.$t("설문을_선택해주세요").toString());
            return;
        }
        // 작성중이 아닌 설문, 승인대기중 설문만 선택대상으로 변경
        let filtered = this.listSelected.filter((i) => !i.isComposing && i.surveyStatus == 1);
        if (!this.selectedCheck(filtered.length)) {
            await (window as any).confirmAsync(this.$t("승인대기중_설문만").toString());
            this.selected = filtered.map((i) => i.surveyId);
        }
        // var approvedSurvey = this.surveyList.surveyLists.filter(s => s.isApproval).map(a => a.surveyId);
        // var notApproved = this.selected.filter(s => !(approvedSurvey.findIndex(a => a == s) >= 0))

        api.survey
            .setSurveyApproval({
                surveyIds: this.selected,
                isApproval: isApproval,
            })
            .then(async (res) => {
                if (this.selected.length > 0) {
                    // 승인대기중 처리건수 표시추가
                    await (window as any).alertAsync(
                        isApproval
                            ? `${this.selected.length} ${this.$t("건_승인").toString()}`
                            : `${this.selected.length} ${this.$t("건_반려").toString()}`
                    );
                }
                this.resetSelectedList();
                this.getList(this.pageSet);
            });
    }

    async deleteSurvey() {
        if (this.listSelected.length == 0) {
            (window as any).alertAsync(this.$t("설문을_선택해주세요").toString());
            return;
        }

        //진행중인 설문 삭제 하는 경우 분기
        let filtered = this.listSelected.filter((i) => i.surveyStatus != 2);
        let filtTxt = this.selectedCheck(filtered.length) ? this.$t("삭제하시겠습니까").toString() : this.$t("진행중인_설문_포함").toString();

        if (await (window as any).confirmAsync(this.$t(filtTxt).toString())) {
            api.survey.deleteSurvey(this.selected).then(async (res) => {
                await (window as any).alertAsync(this.$t("삭제되었습니다").toString());
                this.getList(this.pageSet);
            });
        }
    }

    setMenuTitle() {
        let menuTitle = "";
        const menuConfig = menuHelper.default.findOne(parseInt(this.$route.query.MENUID as string));
        const userConfig = this.current.userConfig;

        menuTitle = this.getLangProperty(menuConfig, "menuName");

        this.setPage({
            title: menuTitle,
        });
    }

    goWrite() {
        //진입전에 surveyId 초기화
        this.setSurveyId();

        this.$router.push({
            name: "SurveyWriteStep01",
            query: {
                ...this.$route.query,
            },
        });
    }

    pageMove(pageSet: survey.SurveyListRequest) {
        this.fethPageset(pageSet);
    }

    switchListPage(isComposing: boolean) {
        this.$router.push({
            name: "SurveyList",
            query: {
                ...this.$route.query,
                isComposing: isComposing ? "1" : "0",
            },
        });
    }

    onClickSearchBtn(params: survey.SurveyListRequest) {
        this.fethPageset(params);
        this.clickSearchBtn = true;
    }

    async notApprover() {
        await (window as any).alertAsync(this.$t("자원_승인자가_아닙니다").toString());
        this.$router.go(-1);
    }

    resetSelectedList() {
        this.listSelected = [];
        var ref = this.$refs.surveyGT as any;
        ref.removeSelected();
    }
}
